import Favorite from '@/js/plugins/CookieDb/Favorite';
import { authCheck } from '@/js/helpers';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const main = async () => {
    if (document.querySelector('#page-property-index') == null) return;

    document.querySelectorAll('select[name="sort"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const sort = e.currentTarget.value;
            document.querySelector(`button[name="sort"][value="${sort}"]`).click();
        });
    });

    // お気に入りのカウント数を表示
    const favorite = new Favorite();
    const targetDb = authCheck() ? 'db' : 'cookie';
    favorite.getAll(targetDb).then((favorites) => {
        const obj = document.querySelector('.p-submit-favorite [data-favorite-count]');
        obj.textContent = favorites.length;
        obj.dataset.count = favorites.length;
    });
}

export default main;
